import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { UpdateEmailFileEntryResponse } from '@/src/components/project/Inbox2/api/updateEmailFileStatus';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { emailFileActivityLogsKeys } from './getEmailFileActivityLogs';
import { emailFileDetailsKeys } from './getEmailFileDetails';

// const url = `${PREFIX_URL}/v01/inboxThread/tagWorkstream`;
const url = `${PREFIX_URL}/inbox-threads/:inboxEntryId/emails/:emailId/attachments/:fileId`;

export type TagEmailFileWorkstreamDTO = {
  inboxEntryId: number;
  emailId: number;
  fileId: number;
  workstreamIds: number[];
};

export const tagEmailFileWorkstream = ({
  inboxEntryId,
  emailId,
  fileId,
  workstreamIds,
}: TagEmailFileWorkstreamDTO): Promise<UpdateEmailFileEntryResponse> => {
  return axios.put(generateRoutePath(url, { inboxEntryId, emailId, fileId }), {
    'workstream-ids': workstreamIds,
  });
};

type useTagEmailFileWorkstreamOptions = {
  projectId: string;
  inboxEntryId: number;
  emailId: number;
  fileId: number;
  config?: MutationConfig<typeof tagEmailFileWorkstream>;
};

export const useTagEmailFileWorkstream = ({
  projectId,
  inboxEntryId,
  emailId,
  fileId,
  config,
}: useTagEmailFileWorkstreamOptions) => {
  return useMutation({
    onSuccess: (data) => {
      // @TODO: check if we need to optimistcally updated email entry workstreams, but we need workstream id for that to work
      // queryClient.setQueryData(
      //   [...emailEntryKeys.detail({ emailId, inboxEntryId, projectId })],
      //   (prev: any) => {
      //     return {
      //       ...prev,
      //       data: {
      //         ...prev.data,
      //         workstreams: data.data.workstreams.map((nws) => ({
      //           ...nws,
      //           'is-permanent': prev.data.workstreams.findIndex((ws) => ws.id === nws.id)
      //             ? prev.data.workstreams.find((ws) => ws.id === nws.id)['is-permanent']
      //             : false,
      //         })),
      //         modifiedDate: modifiedDate,
      //         modifiedBy: modifiedBy,
      //       },
      //     };
      //   }
      // );

      queryClient.setQueryData(
        [...emailFileDetailsKeys.detail({ projectId, emailId, inboxEntryId, fileId })],
        (prev: any) => {
          return {
            ...prev,
            data: data.data['inbox-email-attachment'],
          };
        }
      );

      queryClient.invalidateQueries([
        ...emailFileActivityLogsKeys.detail({ projectId, fileId, emailId, inboxEntryId }),
      ]);
    },
    ...config,
    mutationFn: ({ workstreamIds }) =>
      tagEmailFileWorkstream({ inboxEntryId, emailId, fileId, workstreamIds }),
  });
};
